<template>
    <div id="marker-summary-notes-tab" class="container-fluid mb-5 step-content">
        <div class="row">
            <div class="col-12 d-flex align-items-center justify-content-between">
                <h2 class="title mr-3">Notes</h2>
                <button class="btn-green" role="button" @click="showNotesForm = !showNotesForm">New Note</button>
            </div>
            <transition name="slide-fade">
                <div v-if="showNotesForm === true" class="col-12">
                    <div class="input-belt pt-3 mb-3">
                        <label for="lb-new-note-title">New Note Title</label>
                        <input class type="text" name="title" id="lb-new-note-title" v-model="title"/>
                    </div>

                    <div class="input-belt mb-3">
                        <label for="lb-new-note">New Note</label>
                        <textarea id="lb-new-note" v-model="notes" class="form-control" rows="6" placeholder="..."></textarea>
                    </div>

                    <div class="input-belt mb-3">
                        <application-checkbox
                            class="mb-2"
                            :checked.sync="is_referrer_visible"
                        >Share note with referral partner
                        </application-checkbox>
                    </div>

                    <button v-if="is_referrer_visible" class="btn-light-blue ml-auto" @click="saveNote">Save & Send
                        Note
                    </button>
                    <button v-else class="btn-light-blue ml-auto" @click="saveNote" :disabled=this.checkNotes>Save Note</button>
                </div>
            </transition>
        </div>

        <div class="row">
            <div class="col-12 my-3">
                <table
                    v-if="notesTable.length > 0"
                    class="table amb-vue-table amb-whitebg-vue-table table-hover-rows"
                >
                    <thead>
                    <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Notes</th>
                        <th scope="col">Date</th>
                        <th scope="col">User</th>
                        <th scope="col">Shared with Referrer</th>
                        <th scope="col"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(note, index) in notesTable" :key="note.id">
                        <td>
                            <p class="mb-0">{{ note.title }}</p>
                        </td>

                        <td>
                            <p class="mb-0" v-if="note.title && note.title != 'ScratchPad'">
                                {{ note.title + ' - ' + note.notes }}</p>
                            <p class="mb-0" v-else>{{ note.notes }}</p>
                        </td>

                        <td>
                            <p
                                class="mb-0"
                            >{{
                                    $moment.utc(note.created_at).tz($store.getters.timezone).format("DD/MM/YYYY h:mm:ss a")
                                }}</p>
                        </td>

                        <td>
                            <p class="mb-0">{{ note.full_name }}</p>
                        </td>

                        <td>
                            <p class="mb-0">{{ note.is_referrer_visible ? "Yes" : "No" }}</p>
                        </td>

                        <td class="text-right">
                            <button
                                type="button"
                                class="amb-icon-btn"
                                v-tooltip:top="'Edit note'"
                                data-toggle="modal"
                                data-target="#edit-note"
                                @click="invokeModal(note.id, index)"
                            >
                                <i class="fas fa-edit fa-lg"></i>
                            </button>

                            <button
                                v-tooltip:top="'Add task'"
                                class="amb-icon-btn"
                                @click="addTask(note.id, index)"
                            >
                                <i class="fas fa-tasks fa-lg"></i>
                            </button>

                            <button
                                v-tooltip:top="'Delete note'"
                                class="amb-icon-btn"
                                @click="removeNote(note.id, index)"
                            >
                                <i class="fas fa-trash-alt fa-lg" style="color: #ee4123;"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-else>No notes</div>
            </div>
        </div>
        <x-modal width="600" @cancel="showNoteModel = false" v-if="showNoteModel">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Edit Note
            </div>
            <div>
                <x-row>
                    <div class="col-12">
                        <div class="input-belt">
                            <!-- <label for="title">Note Title</label> -->
                            <input
                                class="form-control"
                                type="hidden"
                                name="title"
                                id="title"
                                value=""
                            />
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-belt pt-3 mb-3">
                            <label for="title">Notes</label>

                            <el-input style="margin-bottom: 20px;" v-model="noteTitle" placeholder="Title"></el-input>

                            <textarea
                                v-model="noteText"
                                class="form-control"
                                rows="6"
                                placeholder="Your Notes"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="input-belt mb-3">
                            <application-checkbox
                                class="mb-2"
                                :checked.sync="note.is_referrer_visible"
                            >Share note with referral partner
                            </application-checkbox>
                        </div>
                    </div>
                </x-row>
            </div>
            <template slot="footer">
                <div></div>
                <div>
                    <x-button @click="showNoteModel = false">Close</x-button>
                    <x-button type="primary" @click="editNote(note.id)">
                        {{ !note.is_referrer_visible ? 'Save changes' : 'Save & Send changes' }}
                    </x-button>
                </div>
            </template>
        </x-modal>

        <x-modal width="600" @cancel="showTaskModel = false" v-if="showTaskModel">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Add Task
            </div>
            <div>
                <x-row>
                    <div class="col-12 mb-3">
                        <div class="input-belt mb-3">
                            <application-input
                                class="input-belt flex-fill mb-3 mt-2"
                                v-model="modal.taskName"
                            >Name
                            </application-input>
                        </div>

                        <div class="row">
                            <div class="col-6 mb-2 input-belt">
                                <el-date-picker
                                    v-model="modal.remindMe"
                                    type="date"
                                    placeholder="Remind me"
                                    value-format="yyyy-MM-dd"
                                    format="dd/MM/yyyy"
                                ></el-date-picker>
                                <!-- TODO send documents required to vuex  -->
                            </div>

                            <div class="col-6 mb-2 input-belt">
                                <el-time-picker
                                    v-model="modal.time"
                                    format="HH:mm"
                                    value-format="HH:mm"
                                    :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59'
                        }"
                                    placeholder="Due Date Time"
                                ></el-time-picker>
                            </div>
                        </div>
                    </div>
                </x-row>
            </div>
            <template slot="footer">
                <div></div>
                <div>
                    <x-button @click="showTaskModel = false">Close</x-button>
                    <x-button type="primary" @click="addTaskFromNotes(modal.selectedNote.id)">
                        Add Task
                    </x-button>
                </div>
            </template>
        </x-modal>
    </div>
</template>


<script>
import {Message} from "element-ui";
import moment from 'moment'
import { mapGetters } from "vuex"
export default {
    data() {
        return {
            title: "",
            showNoteModel: false,
            showTaskModel: false,
            modal: {
                selectedNote: null,
                taskName: "",
                remindMe: this.$moment.utc(new Date()).tz(this.$store.getters.timezone).format('YYYY-MM-DD'),
                time: "17:00",
                visible: false
            },
            noteTitle: '',
            notes: "",
            is_referrer_visible: false,
            showNotesForm: false,
            checkNotes: true,
            appended: false,
            note: {},
            noteText: ""
        };
    },
    computed: {
        notesTable() {
            return this.$store.state.notes.notes;
        }
    },
    watch: {
        notes: {
            handler(val){
                val.length <= 0 ? this.checkNotes = true : this.checkNotes = false

            }
        },
    },
    methods: {
        apiToken() {
            return {
                headers: {Authorization: "Bearer " + this.$store.getters.token}
            };
        },
        addTask(id, index) {
            this.modal.selectedNote = this.$store.state.notes.notes[index];
            this.modal.taskName =
                (this.modal.selectedNote.title ? this.modal.selectedNote.title + " - " : '') + this.modal.selectedNote.notes;
            this.showTaskModel = true;
        },
        addTaskFromNotes(id) {
            axios
                .post(
                    "/api/note/" + id + "/task",
                    {
                        title: this.noteTitle,
                        task_name: this.modal.taskName ? this.modal.taskName : null,
                        time: this.modal.time,
                        due_date: this.modal.remindMe
                    },
                    this.apiToken()
                )
                .then(res => {
                    this.showTaskModel = false;
                    Message({
                        message: "Task Added",
                        type: "success"
                    });
                })
                .catch(err => {
                    console.error(err);
                    Message({
                        message: "Cannot Add Task",
                        type: "error"
                    });
                });
        },
        editNote(id) {
            axios
                .put(
                    "/api/notes/" + id,
                    {
                        // title: this.note.title,
                        // notes: this.note.notes,
                        title: this.noteTitle,
                        notes: this.noteText,
                        is_referrer_visible: this.note.is_referrer_visible
                    },
                    this.apiToken()
                )
                .then(res => {
                    swal({
                        title: "Note Updated",
                        text: "",
                        type: "success"
                    });
                    this.showNoteModel = false;
                })
                .catch(err => {
                    console.error(err);
                    swal({
                        title: "Oops!",
                        text: err,
                        type: "error"
                    });
                });
        },
        invokeModal(id, index) {
            this.note = this.notesTable[index];
            this.noteTitle = this.note.title
            this.noteText = this.note.notes;

            //   if(this.note.title && this.note.title != 'ScratchPad') this.noteText = this.note.title+' - '+this.note.notes;
            //   else this.noteText = this.note.notes;
            this.showNoteModel = true;
        },
        removeNote(id, index) {
            axios
                .delete("/api/notes/" + id, this.apiToken())
                .then(res => {
                    this.notesTable.splice(index, 1);
                })
                .catch(err => {
                    console.error(err);
                });
        },
        saveNote() {
            let self = this;
            axios
                .post(
                    "/api/notes",
                    {
                        title: this.title,
                        notes: this.notes,
                        application_id: applicationId,
                        is_referrer_visible: this.is_referrer_visible
                    },
                    this.apiToken()
                )
                .then(res => {
                    self.showNotesForm = false;
                    self.title = this.notes = "";
                    this.$store.dispatch("notes/saveNote", res.data);
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },
    activated() {
    },
    created() {
        axios
            .get("/api/application/" + applicationId + "/notes", this.apiToken())
            .then(res => {
                this.$store.dispatch("notes/saveNotes", res.data);
            })
            .catch(err => {
                console.error(err);
            });
    }
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
    transition: all 0.8s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
{
    transform: translateX(10px);
    opacity: 0;
}
</style>
